// src/components/auth/ForgotPasswordForm.js
import React, { useState } from 'react';
import {
  TextField,
  Button,
  CircularProgress,
  Alert,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

const FormContainer = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');

    try {
      
      const baseUrl = process.env.REACT_APP_HOST && process.env.REACT_APP_PORT
            ? `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}/api/`
              : 'http://localhost:3000/api/';

      const response = await fetch(`${baseUrl}account/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
      } else {
        setError(data.message || 'Erro ao processar a solicitação.');
      }
    } catch (err) {
      setError('Erro de conexão. Por favor, tente novamente mais tarde.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>Esqueceu a Senha?</Typography>
    <FormContainer component="form" onSubmit={handleSubmit}>
      <Typography variant="body2">
        Digite seu e-mail para receber um link de redefinição.
      </Typography>

      <TextField
        fullWidth
        label="E-mail"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      {isLoading && <CircularProgress size={24} sx={{ alignSelf: 'center' }} />}
      {message && <Alert severity="success">{message}</Alert>}
      {error && <Alert severity="error">{error}</Alert>}

      <Button
        fullWidth
        variant="contained"
        type="submit"
        size="large"
        disabled={isLoading}
      >
        Enviar Link de Redefinição
      </Button>
    </FormContainer>
    </>
  );
};

export default ForgotPasswordForm;